import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-delivery-slow",
  "use": "icon-icon-delivery-slow-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon-delivery-slow\">\n    <title>icons/icon-delivery-slow</title>\n    <g id=\"icon-icon-delivery-slow_icons/icon-delivery-slow\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <circle id=\"icon-icon-delivery-slow_Oval-Copy\" fill=\"#FF3960\" cx=\"12\" cy=\"12\" r=\"4\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol